export default __webpack_public_path__ + "static/media/uplay_83657.5c13199f.png";